import React from "react";
import cookie from "react-cookies";
import MoRenLogo from 'file-loader!../site/source/images/moren_logo.png';
import store from "./store";
import {SWITCH_LOGO} from "./store/actionType";
import {connect} from 'react-redux'
import {LEGAL_NAME} from "./source/js/common";

class IndexUserImg extends React.Component{
    state={
        imgCodeUrl:''
    };
    async componentDidMount() {
        let logoImg = await this.getLogoImg();
        this.setState({
            imgCodeUrl:logoImg
        })
            //订阅登入之后刷新菜单
            store.subscribe(async ()=>{
                if(store.getState().switchLogo.type==SWITCH_LOGO){
                    await this.getLogoImg();
                }
            })
    }
    async componentWillReceiveProps(nextprops){
        let logoImg = await this.getLogoImg();
        this.setState({
            imgCodeUrl:logoImg
        })
        this.props.foo(false)
        return true
    }

    //判断头像是否可用
    async checkImgExists(imgurl) {
        return new Promise(function(resolve, reject) {
            var ImgObj = new Image();
            ImgObj.src = imgurl;
            ImgObj.onload = function(res) {
                resolve(res);
            }
            ImgObj.onerror = function(err) {
                reject(err)
            }
        })
    }



    async getLogoImg(){
        //  const imgSrc = await post('/notice/aisino/attachmentManagement/getDocumentIdByTinOrNin');
        // if(imgSrc != null){
        //     let imgUrl = axios.defaults.baseURL + "/notice/aisino/attachmentManagement/previewImgById?id=" + imgSrc.id+"&b="+Date.parse(new Date())/1000;
        //     let data;
        //     await this.checkImgExists(imgUrl).then(()=>{
        //         // console.log('有效链接')
        //         data = imgUrl;
        //     }).catch(()=>{
        //         // console.log('无效链接')
        //         data = MoRenLogo;
        //     })
        //     return data;
        // }else{
            return MoRenLogo
        // }
        // return MoRenLogo;
    }
    render() {
        return (
            <div style={{height:"42px",display:"inline-block"}}>
                <img src={this.state.imgCodeUrl}
                     style={{marginLeft:16,display:cookie.load(LEGAL_NAME)!=null?'':'none'}}
                 alt={""}/>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        upLoadLogo:state.upLoadLogo
    }
}
const mapDispathToProps = {
    foo : (data) => {
      return {
        type: "upLoadLogo",
        payload: data
      }
    }
  }
export default connect(mapStateToProps,mapDispathToProps)(IndexUserImg);
